module.exports = __webpack_public_path__ + "img/lightbox_tpr.3443be35.png";